import React from 'react';

export default function Header() {
  return (
    <header className="header">
      <div className="header-brand">
        <div className="header-logo">
          <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="header-logo-svg">
            <defs>
              <linearGradient id="shieldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#60a5fa" />
                <stop offset="50%" stopColor="#38bdf8" />
                <stop offset="100%" stopColor="#06b6d4" />
              </linearGradient>
              <linearGradient id="innerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#93c5fd" />
                <stop offset="100%" stopColor="#22d3ee" />
              </linearGradient>
              <filter id="glow">
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            {/* Outer shield */}
            <path
              d="M24 4L6 12v10c0 11.1 7.7 21.5 18 24 10.3-2.5 18-12.9 18-24V12L24 4z"
              fill="url(#shieldGrad)"
              opacity="0.15"
              className="shield-outer"
            />
            {/* Shield border */}
            <path
              d="M24 4L6 12v10c0 11.1 7.7 21.5 18 24 10.3-2.5 18-12.9 18-24V12L24 4z"
              fill="none"
              stroke="url(#shieldGrad)"
              strokeWidth="2"
              strokeLinejoin="round"
              className="shield-border"
            />
            {/* Inner shield accent */}
            <path
              d="M24 9l-13 5.8v7.4c0 8.4 5.6 16.2 13 18.2 7.4-2 13-9.8 13-18.2v-7.4L24 9z"
              fill="url(#shieldGrad)"
              opacity="0.08"
            />
            {/* Scanning eye / radar circle */}
            <circle
              cx="24" cy="22" r="7"
              fill="none"
              stroke="url(#innerGrad)"
              strokeWidth="1.5"
              opacity="0.7"
              className="scan-ring"
            />
            <circle
              cx="24" cy="22" r="3.5"
              fill="none"
              stroke="url(#innerGrad)"
              strokeWidth="1.2"
              opacity="0.5"
              className="scan-ring-inner"
            />
            {/* Center dot */}
            <circle
              cx="24" cy="22" r="1.8"
              fill="url(#innerGrad)"
              filter="url(#glow)"
              className="scan-dot"
            />
            {/* Scan line sweep */}
            <line
              x1="24" y1="22" x2="24" y2="15"
              stroke="url(#innerGrad)"
              strokeWidth="1.5"
              strokeLinecap="round"
              opacity="0.8"
              className="scan-sweep"
            />
            {/* Check mark */}
            <path
              d="M20 33l3 3 6-6"
              fill="none"
              stroke="#34d399"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              filter="url(#glow)"
              className="check-mark"
            />
          </svg>
          <div className="logo-pulse-ring" />
        </div>
        <div>
          <div className="header-title">URL Security Scanner</div>
          <div className="header-subtitle">Threat Intelligence Platform</div>
        </div>
      </div>
      <div className="header-status">
        <span className="status-dot" />
        Sistema Operacional
      </div>
    </header>
  );
}
